class CakeAddons {
  constructor() {
    this.selected = new Map();
    this.cards = document.querySelectorAll('.cake-addon-card');
    this.form = document.querySelector('form[action="/cart/add"]');
    this.init();
  }

  init() {
    this.cards.forEach(card => {
      card.querySelector('.cake-addon-card__toggle')
        .addEventListener('click', () => this.toggle(card));
    });

    this.form?.addEventListener('submit', (e) => {
      this.handleSubmit(e);
    });
  }

  toggle(card) {
    const id    = card.dataset.addonId;
    const price = parseInt(card.dataset.addonPrice, 10);
    const title = card.dataset.addonTitle;
    const btn   = card.querySelector('.cake-addon-card__toggle');

    if (this.selected.has(id)) {
      this.selected.delete(id);
      card.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    } else {
      this.selected.set(id, { price, title });
      card.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
    }
    this.updateSummary();
  }

  updateSummary() {
    const count = this.selected.size;
    const total = [...this.selected.values()]
      .reduce((sum, a) => sum + a.price, 0);

    const countEl = document.getElementById('addon-count');
    const totalEl = document.getElementById('addon-total');

    countEl.textContent = count === 0
      ? 'No add-ons selected'
      : `${count} add-on${count > 1 ? 's' : ''} selected`;

    totalEl.textContent = count > 0
      ? `+${(total / 100).toFixed(2)} ${window.Shopify?.currency?.active || 'USD'}`
      : '';
  }

  async handleSubmit(e) {
    e.preventDefault();
    const form = e.target;

    const mainItem = {
      id: form.querySelector('[name="id"]').value,
      quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1, 10)
    };

    const addonItems = [...this.selected.keys()].map(id => ({
      id,
      quantity: 1,
      properties: { '_addon_for': mainItem.id }
    }));

    const items = [mainItem, ...addonItems];

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart error');
      window.location.href = '/cart';
    } catch (err) {
      console.error('Add-on cart error:', err);
      form.submit();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.cake-addons-wrapper')) {
    new CakeAddons();
  }
});